import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Button from "components/Button/Button";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Footer from 'components/Footer/Footer';
import './style.css';
import home from 'Assets/home.svg';
const NotFound = () => (
<div>
<Helmet>
  <title>PechaKucha 404</title>
  <meta name="prerender-status-code" content="501" />
  <meta name="robots" content="noindex" />
</Helmet>
  <div className="noPage">
    {/* <img src={PageNotFound} style={{width: "100%", height: 686, margin: 'auto', position: 'relative' }} /> */}
    <div className="notFoundContainer">
      <div className="container">
        
          <Row>
            <Col lg={3} md={2} sm={0}></Col>
            <Col lg={8} md={10} sm={12}>
            <div className="oopsData">
              <div className="pageNotFound">
                <h1>Page Not Found</h1>
                <p>Oops! The page you are looking for does not exist. Sometimes you have to get 
                  lost before you find what you are looking for.
                </p>
                <Link to="/">
                <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 goback-btn">
                  Go Back
                </Button>
                </Link>
              </div>
              </div>
            </Col>
          </Row>
       
      </div>
    </div>
    <Footer
    homeImg={home}
    homeImgRef="/"
    />
  </div>
</div>
);

export default NotFound;